/**
 * Utility functions for Activity Log components
 */

const API_BASE = process.env.REACT_APP_API_URL || "";

/**
 * Format underscore-separated text to space-separated
 * @param {string} text - Text with underscores
 * @returns {string} - Formatted text
 */
export const formatUnderscoreText = (text) => {
  if (!text) return "—";
  return String(text).replace(/_/g, " ");
};

/**
 * Convert relative URLs to absolute URLs using API base
 * @param {string} url - Relative or absolute URL
 * @returns {string} - Absolute URL
 */
export const toAbsoluteUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `${API_BASE}${url}`;
};

/**
 * Safely parse JSON value
 * @param {any} value - Value to parse
 * @returns {any} - Parsed value or original value
 */
export const parseJSONSafely = (value) => {
  if (!value || value === "null") return null;
  try {
    return typeof value === "string" ? JSON.parse(value) : value;
  } catch {
    return value;
  }
};

/**
 * Check if field name indicates a timestamp
 * @param {string} key - Field name
 * @returns {boolean}
 */
export const isTimestampField = (key) => {
  if (!key) return false;
  const lowerKey = key.toLowerCase();
  return (
    lowerKey.includes("timestamp") ||
    lowerKey.includes("date") ||
    lowerKey.includes("time") ||
    lowerKey.includes("created_at") ||
    lowerKey.includes("updated_at")
  );
};

/**
 * Check if field name indicates a URL
 * @param {string} key - Field name
 * @returns {boolean}
 */
export const isUrlField = (key) => {
  if (!key) return false;
  const lowerKey = key.toLowerCase();
  return (
    lowerKey.includes("url") ||
    lowerKey.includes("image") ||
    lowerKey.includes("file") ||
    lowerKey.includes("document")
  );
};

/**
 * Check if value is a clickable URL
 * @param {any} value - Value to check
 * @returns {boolean}
 */
export const isClickableUrl = (value) => {
  return (
    typeof value === "string" &&
    (value.startsWith("http") || value.startsWith("/"))
  );
};
